namespace PaperTrail.NewsletterControl {
    export interface SubscriptionRow {
        SubscriptionId?: number;
        SubscriptionName?: string;
        CreatedBy?: number;
        DateCreated?: string;
        Frequency?: string;
        EditorUserId?: number;
        UsersList?: number[];
        Newsletters?: NewsletterRow[];
        CreatedByUsername?: string;
        CreatedByDisplayName?: string;
        CreatedByEmail?: string;
        CreatedBySource?: string;
        CreatedByLastDirectoryUpdate?: string;
        CreatedByUserImage?: string;
        CreatedByInsertDate?: string;
        CreatedByInsertUserId?: number;
        CreatedByUpdateDate?: string;
        CreatedByUpdateUserId?: number;
        CreatedByIsActive?: number;
        CreatedByMobilePhoneNumber?: string;
        CreatedByMobilePhoneVerified?: boolean;
        CreatedByTwoFactorAuth?: number;
        EditorUserUsername?: string;
        EditorUserDisplayName?: string;
        EditorUserEmail?: string;
        EditorUserSource?: string;
        EditorUserLastDirectoryUpdate?: string;
        EditorUserUserImage?: string;
        EditorUserInsertDate?: string;
        EditorUserInsertUserId?: number;
        EditorUserUpdateDate?: string;
        EditorUserUpdateUserId?: number;
        EditorUserIsActive?: number;
        EditorUserMobilePhoneNumber?: string;
        EditorUserMobilePhoneVerified?: boolean;
        EditorUserTwoFactorAuth?: number;
    }

    export namespace SubscriptionRow {
        export const idProperty = 'SubscriptionId';
        export const nameProperty = 'SubscriptionName';
        export const localTextPrefix = 'Subscription.Subscription';
        export const lookupKey = 'NewsletterControl.Subscription';

        export function getLookup(): Q.Lookup<SubscriptionRow> {
            return Q.getLookup<SubscriptionRow>('NewsletterControl.Subscription');
        }
        export const deletePermission = 'Newsletter:Contributor';
        export const insertPermission = 'Newsletter:Contributor';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Newsletter:Contributor';

        export declare const enum Fields {
            SubscriptionId = "SubscriptionId",
            SubscriptionName = "SubscriptionName",
            CreatedBy = "CreatedBy",
            DateCreated = "DateCreated",
            Frequency = "Frequency",
            EditorUserId = "EditorUserId",
            UsersList = "UsersList",
            Newsletters = "Newsletters",
            CreatedByUsername = "CreatedByUsername",
            CreatedByDisplayName = "CreatedByDisplayName",
            CreatedByEmail = "CreatedByEmail",
            CreatedBySource = "CreatedBySource",
            CreatedByLastDirectoryUpdate = "CreatedByLastDirectoryUpdate",
            CreatedByUserImage = "CreatedByUserImage",
            CreatedByInsertDate = "CreatedByInsertDate",
            CreatedByInsertUserId = "CreatedByInsertUserId",
            CreatedByUpdateDate = "CreatedByUpdateDate",
            CreatedByUpdateUserId = "CreatedByUpdateUserId",
            CreatedByIsActive = "CreatedByIsActive",
            CreatedByMobilePhoneNumber = "CreatedByMobilePhoneNumber",
            CreatedByMobilePhoneVerified = "CreatedByMobilePhoneVerified",
            CreatedByTwoFactorAuth = "CreatedByTwoFactorAuth",
            EditorUserUsername = "EditorUserUsername",
            EditorUserDisplayName = "EditorUserDisplayName",
            EditorUserEmail = "EditorUserEmail",
            EditorUserSource = "EditorUserSource",
            EditorUserLastDirectoryUpdate = "EditorUserLastDirectoryUpdate",
            EditorUserUserImage = "EditorUserUserImage",
            EditorUserInsertDate = "EditorUserInsertDate",
            EditorUserInsertUserId = "EditorUserInsertUserId",
            EditorUserUpdateDate = "EditorUserUpdateDate",
            EditorUserUpdateUserId = "EditorUserUpdateUserId",
            EditorUserIsActive = "EditorUserIsActive",
            EditorUserMobilePhoneNumber = "EditorUserMobilePhoneNumber",
            EditorUserMobilePhoneVerified = "EditorUserMobilePhoneVerified",
            EditorUserTwoFactorAuth = "EditorUserTwoFactorAuth"
        }
    }
}
